import { z } from "zod";

export const driversHistoryByVehiclePayloadSchema = z.object({
  vehicleUuid: z.uuid(),
  from: z.union([z.date(), z.iso.datetime()]).optional(),
});

export type DriversHistoryByVehiclePayload = z.infer<
  typeof driversHistoryByVehiclePayloadSchema
>;
